var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useRef, useState } from "react";
import { regexPasswordValidation } from "../../shared/regex";
import { useDispatch, useSelector } from "react-redux";
import { isAuthorized } from "../../services/behaviorSubjectService";
import { SalesRepDataActionType } from "../../reduxStore/actions/actionTypes";
import { updatePasswordAction, uploadAffiliatePhotoAction, removeProfileImageAction } from "../../reduxStore/actions/salesRepDataAction";
import { DashboardBL } from "../DashboardLayout/DashboardBL";
import { useTranslation } from "react-i18next";
import { isNullOrEmpty, useDeviceQueries, useFullScreenToggle, goToWebsite, getThemePrimaryColor } from "../../shared/Utilites";
export function NavbarBL() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var t = useTranslation().t;
    var _s = DashboardBL(), loggedInRepData = _s.loggedInRepData, getTimeZone = _s.getTimeZone;
    var isMobile = useDeviceQueries();
    var dispatch = useDispatch();
    var profile = useSelector(function (state) { return state.salesRepData; });
    var repName = (_a = profile === null || profile === void 0 ? void 0 : profile.loggedInRepDetails) === null || _a === void 0 ? void 0 : _a.customerName;
    var propsColor = { color: "black" };
    var defaultFormValues = { currentPassword: "", newPassword: "", confirmPassword: "" };
    var _t = useState(false), passwordDialog = _t[0], setPasswordDialog = _t[1];
    var profileSrc = (_c = (_b = profile.baseData) === null || _b === void 0 ? void 0 : _b.SingleSalesRep) === null || _c === void 0 ? void 0 : _c.ProfileImagePath;
    var repType = (_e = (_d = profile === null || profile === void 0 ? void 0 : profile.baseData) === null || _d === void 0 ? void 0 : _d.SingleSalesRep) === null || _e === void 0 ? void 0 : _e.RepType;
    var repFirstName = (_g = (_f = profile === null || profile === void 0 ? void 0 : profile.baseData) === null || _f === void 0 ? void 0 : _f.SingleSalesRep) === null || _g === void 0 ? void 0 : _g.SalesRepName;
    var repLastName = (_j = (_h = profile === null || profile === void 0 ? void 0 : profile.baseData) === null || _h === void 0 ? void 0 : _h.SingleSalesRep) === null || _j === void 0 ? void 0 : _j.SalesRepLastName;
    var repFullName = "".concat(repFirstName || "", " ").concat(repLastName || "");
    var profilePic = (_k = profile === null || profile === void 0 ? void 0 : profile.baseData) === null || _k === void 0 ? void 0 : _k.SingleSalesRep;
    var _u = useState(defaultFormValues), passwordForm = _u[0], setPasswordForm = _u[1];
    var _v = useState({ currentPasswordErrMsg: "", newPasswordErrMsg: "", confirmPasswordErrMsg: "" }), formErrMsg = _v[0], setFormErrMsg = _v[1];
    var resetBtnEnabled = ((_l = passwordForm.currentPassword) === null || _l === void 0 ? void 0 : _l.length) > 0 &&
        ((_m = passwordForm.newPassword) === null || _m === void 0 ? void 0 : _m.length) > 0 &&
        ((_o = passwordForm.confirmPassword) === null || _o === void 0 ? void 0 : _o.length) > 0 &&
        formErrMsg.currentPasswordErrMsg === "" &&
        formErrMsg.newPasswordErrMsg === "" &&
        formErrMsg.confirmPasswordErrMsg === "";
    var _w = useState(false), updatePasswordSuccess = _w[0], setUpdatePasswordSuccess = _w[1];
    var _x = useState(false), restLoadingFlag = _x[0], setResetLoadingFlag = _x[1];
    var _y = useState({ successMsg: "", errorMsg: "" }), passwordErrMsg = _y[0], setPasswordErrMsg = _y[1];
    var imageState = {
        isLoading: false,
        imageName: "",
        imagePreview: !isNullOrEmpty(profilePic === null || profilePic === void 0 ? void 0 : profilePic.ProfileImagePath) ? profilePic.ProfileImagePath : "",
        imageSize: 0,
    };
    var _z = useState({
        currentPassword: false,
        newPassword: false,
        confirmPassword: false,
    }), showPassword = _z[0], setShowPassword = _z[1];
    // ================ SET PROFILE IMAGE =============================
    var uploadInputImage = useRef(null);
    var _0 = useState(""), helperImage = _0[0], setHelperImageText = _0[1];
    var _1 = useState(false), imageError = _1[0], setImageError = _1[1];
    var _2 = useState(false), isImageInput = _2[0], setIsImageInput = _2[1];
    var _3 = useState(), file = _3[0], setProfile = _3[1];
    var _4 = useState(false), showNewImage = _4[0], setShowNewImage = _4[1];
    var _5 = useState(imageState), image = _5[0], setImage = _5[1];
    var _6 = useState(t("yourBio_button2")), uploadImageState = _6[0], setUploadImageState = _6[1];
    var _7 = useState(false), imageLoading = _7[0], setImageLoading = _7[1];
    var _8 = useState(false), openCommissionDialog = _8[0], setOpenCommissionDialog = _8[1];
    var imagePreview = image.imagePreview;
    var hasExistingImage = !!imagePreview;
    var ShopBusinessName = (_q = (_p = profile.baseData) === null || _p === void 0 ? void 0 : _p.ShopBusinessName) !== null && _q !== void 0 ? _q : (_r = loggedInRepData === null || loggedInRepData === void 0 ? void 0 : loggedInRepData.shopName) === null || _r === void 0 ? void 0 : _r.replace(/.myshopify.com/g, "");
    // Common function to check if field is a password field
    var isPasswordField = function (fieldName) {
        return fieldName === "currentPassword" || fieldName === "newPassword" || fieldName === "confirmPassword";
    };
    var userLogout = function () { return __awaiter(_this, void 0, void 0, function () {
        var action;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    sessionStorage.setItem("Authorization", "");
                    isAuthorized.next(false);
                    sessionStorage.clear();
                    setShowNewImage(false);
                    console.log("logout");
                    action = {
                        payload: "",
                        type: SalesRepDataActionType.RESET_INITIAL_STATE,
                    };
                    return [4 /*yield*/, dispatch(action)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var themePrimaryColor = getThemePrimaryColor();
    var _9 = useFullScreenToggle(), fullScreen = _9.fullScreen, toggleFullScreen = _9.toggleFullScreen;
    function stringAvatar(name) {
        return {
            sx: {
                bgcolor: "#d0f4ff",
                color: "#1976d2",
                fontSize: "1rem",
                borderRadius: "50%",
            },
            children: "".concat(name === null || name === void 0 ? void 0 : name.split(" ")[0][0]).concat(name === null || name === void 0 ? void 0 : name.split(" ")[1][0]),
        };
    }
    var changeFormValue = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        var processedValue = value;
        // Null check for value
        if (value == null) {
            processedValue = "";
        }
        // Handle password fields - prevent spaces from being entered
        if (isPasswordField(name)) {
            // Remove all spaces from the input
            processedValue = processedValue.replace(/\s/g, "");
        }
        setPasswordForm(__assign(__assign({}, passwordForm), (_a = {}, _a[name] = processedValue, _a)));
        fieldsValidation(name, processedValue);
    };
    var handleKeyDown = function (event) {
        var _a;
        var fieldName = ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.name) || "";
        var key = event.key || "";
        var keyCode = event.keyCode || 0;
        // Null check for fieldName
        if (fieldName === "" || fieldName == null) {
            return;
        }
        // Prevent space character in password fields
        if (isPasswordField(fieldName) && key === " ") {
            event.preventDefault();
            return;
        }
        if (key === "Enter" && keyCode === 13 && resetBtnEnabled) {
            resetPassword();
        }
    };
    var handlePaste = function (event) {
        var _a;
        var _b;
        var fieldName = ((_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.name) || "";
        var clipboardData = (event === null || event === void 0 ? void 0 : event.clipboardData) || null;
        // Null check for fieldName
        if (fieldName === "" || fieldName == null) {
            return;
        }
        // Prevent spaces from being pasted in password fields
        if (isPasswordField(fieldName)) {
            event.preventDefault();
            var pastedText = (clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.getData("text")) || "";
            var cleanedText = (pastedText || "").replace(/\s/g, "");
            // Update the field with cleaned text
            setPasswordForm(__assign(__assign({}, passwordForm), (_a = {}, _a[fieldName] = cleanedText, _a)));
            fieldsValidation(fieldName, cleanedText);
        }
    };
    var fieldsValidation = function (name, value) {
        var _a;
        switch (name) {
            case "":
                value === ""
                    ? setFormErrMsg(function (values) { return (__assign(__assign({}, values), { currentPasswordErrMsg: t("resetPassword_validation_Msg") })); })
                    : value.match(regexPasswordValidation)
                        ? setFormErrMsg(function (values) { return (__assign(__assign({}, values), { currentPasswordErrMsg: "" })); })
                        : setFormErrMsg(function (values) { return (__assign(__assign({}, values), { currentPasswordErrMsg: t("resetPassword_validation_Msg2") })); });
                break;
            case "newPassword":
                value === ""
                    ? setFormErrMsg(function (values) { return (__assign(__assign({}, values), { newPasswordErrMsg: t("resetPassword_validation_Msg") })); })
                    : value.match(regexPasswordValidation)
                        ? setFormErrMsg(function (values) { return (__assign(__assign({}, values), { newPasswordErrMsg: "" })); })
                        : setFormErrMsg(function (values) { return (__assign(__assign({}, values), { newPasswordErrMsg: t("resetPassword_validation_Msg2") })); });
                value !== passwordForm.confirmPassword && ((_a = passwordForm.confirmPassword) === null || _a === void 0 ? void 0 : _a.length) > 0
                    ? setFormErrMsg(function (values) { return (__assign(__assign({}, values), { confirmPasswordErrMsg: t("resetPassword_validation_Msg3") })); })
                    : setFormErrMsg(function (values) { return (__assign(__assign({}, values), { confirmPasswordErrMsg: "" })); });
                break;
            case "confirmPassword":
                value === ""
                    ? setFormErrMsg(function (values) { return (__assign(__assign({}, values), { confirmPasswordErrMsg: t("resetPassword_validation_Msg") })); })
                    : value === passwordForm.newPassword
                        ? setFormErrMsg(function (values) { return (__assign(__assign({}, values), { confirmPasswordErrMsg: "" })); })
                        : setFormErrMsg(function (values) { return (__assign(__assign({}, values), { confirmPasswordErrMsg: t("resetPassword_validation_Msg3") })); });
                break;
        }
    };
    var resetPassword = function () { return __awaiter(_this, void 0, void 0, function () {
        var passwordResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setResetLoadingFlag(true);
                    return [4 /*yield*/, dispatch(updatePasswordAction(passwordForm))];
                case 1:
                    passwordResponse = _a.sent();
                    if ((passwordResponse === null || passwordResponse === void 0 ? void 0 : passwordResponse.status) == 200) {
                        setUpdatePasswordSuccess(true);
                        setPasswordErrMsg({ errorMsg: "", successMsg: passwordResponse.message });
                        setFormErrMsg({ currentPasswordErrMsg: "", newPasswordErrMsg: "", confirmPasswordErrMsg: "" });
                        setPasswordForm(defaultFormValues);
                    }
                    else {
                        setPasswordErrMsg({ successMsg: "", errorMsg: passwordResponse.message });
                    }
                    setResetLoadingFlag(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var clearFormValues = function () {
        setPasswordDialog(false);
        setPasswordForm(defaultFormValues);
        setUpdatePasswordSuccess(false);
        setPasswordErrMsg({ successMsg: "", errorMsg: "" });
        setFormErrMsg({ currentPasswordErrMsg: "", newPasswordErrMsg: "", confirmPasswordErrMsg: "" });
    };
    var viewProps = {
        noWrap: true,
        flexGrow: 1,
        sx: {
            fontWeight: isMobile ? 700 : 610,
            textDecoration: "none",
            display: isMobile ? { xs: "flex", md: "none" } : { xs: "none", md: "flex" },
            fontFamily: "'Inter', sans-serif",
            backgroundColor: "#FFF",
        },
    };
    var handlePasswordDialogOpen = function () {
        setPasswordDialog(true);
    };
    var handleUploadImage = function (_a) {
        var files = _a.target.files;
        return __awaiter(_this, void 0, void 0, function () {
            var file;
            return __generator(this, function (_b) {
                setHelperImageText("");
                setImageError(false);
                file = files[0];
                if (!isNullOrEmpty(file)) {
                    if (file.size < 5000000) {
                        setImage(function (prevState) { return (__assign(__assign({}, prevState), { isLoading: true })); });
                        setProfile(file);
                        setShowNewImage(true);
                        setImage(function (prevState) { return (__assign(__assign({}, prevState), { imageName: file.name, imagePreview: URL.createObjectURL(file), imageSize: file.size, isLoading: false })); });
                    }
                    else {
                        setTimeout(function () {
                            setImageError(false);
                        }, 3000);
                        setImageError(true);
                        setHelperImageText(t("yourBio_error_image_size"));
                        setImage(imageState);
                        uploadInputImage.current.value = null;
                    }
                }
                else {
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    var uploadImage = function () { return __awaiter(_this, void 0, void 0, function () {
        var uploadPhotoStatus, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setUploadImageState(t("yourBio_Uploadbtn1"));
                    setImageLoading(true);
                    setHelperImageText("");
                    setImageError(false);
                    setIsImageInput(true);
                    if (!(!isNullOrEmpty(file) && image.imageSize < 5000000 && image.imagePreview !== "")) return [3 /*break*/, 3];
                    _a = file;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(uploadAffiliatePhotoAction(file))];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    uploadPhotoStatus = _a;
                    if (uploadPhotoStatus) {
                        setUploadImageState(t("yourBio_Uploadbtn2"));
                        setImage(function (prevState) { return (__assign(__assign({}, prevState), { isLoading: false })); });
                        setHelperImageText("");
                        setImageError(false);
                    }
                    else {
                        setImageError(true);
                        setImage(imageState);
                        uploadInputImage.current.value = null;
                        setUploadImageState(t("yourBio_button2"));
                        setHelperImageText(t("addCustomer_leadErrrorMsg"));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setHelperImageText(t("yourBio_error_image_size"));
                    setImageError(true);
                    setShowNewImage(false);
                    setImage(imageState);
                    uploadInputImage.current.value = null;
                    _b.label = 4;
                case 4:
                    setTimeout(function () {
                        setImageError(false);
                    }, 3000);
                    setShowNewImage(false);
                    setImageLoading(false);
                    setIsImageInput(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleTogglePassword = function (field) {
        setShowPassword(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = !prev[field], _a)));
        });
    };
    var removeProfileImage = function () { return __awaiter(_this, void 0, void 0, function () {
        var successremove;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setImageLoading(true);
                    if (uploadInputImage.current)
                        uploadInputImage.current.value = "";
                    setShowNewImage(false);
                    return [4 /*yield*/, dispatch(removeProfileImageAction())];
                case 1:
                    successremove = _a.sent();
                    if (!successremove) {
                        setImageError(true);
                        setHelperImageText(t("Remove_Image_Error"));
                    }
                    else {
                        setImage(function (prev) { return (__assign(__assign({}, prev), { imagePreview: "", imageName: "", imageSize: 0 })); });
                    }
                    setImageLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleProfileImagePopup = function () {
        var file = profilePic === null || profilePic === void 0 ? void 0 : profilePic.ProfileImagePath;
        setOpenCommissionDialog(false);
        setTimeout(function () {
            setImage(function (prevState) { return (__assign(__assign({}, prevState), { imagePreview: file, isLoading: false })); });
            setShowNewImage(false);
        }, 300);
    };
    return {
        loggedInRepData: loggedInRepData,
        getTimeZone: getTimeZone,
        repName: repName,
        propsColor: propsColor,
        passwordDialog: passwordDialog,
        profileSrc: profileSrc,
        updatePasswordSuccess: updatePasswordSuccess,
        restLoadingFlag: restLoadingFlag,
        passwordErrMsg: passwordErrMsg,
        userLogout: userLogout,
        goToWebsite: goToWebsite,
        themePrimaryColor: themePrimaryColor,
        fullScreen: fullScreen,
        toggleFullScreen: toggleFullScreen,
        stringAvatar: stringAvatar,
        changeFormValue: changeFormValue,
        handleKeyDown: handleKeyDown,
        handlePaste: handlePaste,
        resetPassword: resetPassword,
        clearFormValues: clearFormValues,
        viewProps: viewProps,
        handlePasswordDialogOpen: handlePasswordDialogOpen,
        passwordForm: passwordForm,
        resetBtnEnabled: resetBtnEnabled,
        formErrMsg: formErrMsg,
        t: t,
        isMobile: isMobile,
        repFullName: repFullName,
        repType: repType,
        openCommissionDialog: openCommissionDialog,
        setOpenCommissionDialog: setOpenCommissionDialog,
        isImageInput: isImageInput,
        showNewImage: showNewImage,
        profile: profile,
        uploadInputImage: uploadInputImage,
        setImage: setImage,
        image: image,
        uploadImageState: uploadImageState,
        imageLoading: imageLoading,
        handleUploadImage: handleUploadImage,
        uploadImage: uploadImage,
        helperImage: helperImage,
        imageError: imageError,
        imagePreview: imagePreview,
        profilePic: profilePic,
        showPassword: showPassword,
        handleTogglePassword: handleTogglePassword,
        ShopBusinessName: ShopBusinessName,
        removeProfileImage: removeProfileImage,
        handleProfileImagePopup: handleProfileImagePopup,
        hasExistingImage: hasExistingImage,
    };
}
